export const EmployeePersonalInfoConfig: Record<string, string>[] = [
  {
    key: "id",
    displayTitle: "Employee Id"
  },
  {
    key: "email",
    displayTitle: "Email"
  },
  {
    key: "firstName",
    displayTitle: "Firstname"
  },
  {
    key: "phoneNumber",
    displayTitle: "Phone number"
  },
  {
    key: "lastName",
    displayTitle: "Lastname"
  },
  {
    key: "hiredEmployeeInfo.dateOfBirth",
    displayTitle: "Date of Birth"
  }
];

export const EmployeeWorkInfoConfig: Record<string, string>[] = [
  {
    key: "alias",
    displayTitle: "Alias"
  },
  {
    key: "role",
    displayTitle: "Role"
  },
  {
    key: "hiredEmployeeInfo.isVerified",
    displayTitle: "Is verified"
  },
  {
    key: "hiredEmployeeInfo.hireStatus",
    displayTitle: "Hire status"
  },
  {
    key: "hiredEmployeeInfo.employmentType",
    displayTitle: "Employment Type"
  },
  {
    key: "hiredEmployeeInfo.positions",
    displayTitle: "Positions"
  },
  {
    key: "hiredEmployeeInfo.employmentDuration",
    displayTitle: "Employment Duration"
  },
  {
    key: "hiredEmployeeInfo.hireDate",
    displayTitle: "Hired date"
  },
  {
    key: "hiredEmployeeInfo.rehireDate",
    displayTitle: "Rehired date"
  },
  {
    key: "hiredEmployeeInfo.resignDate",
    displayTitle: "Resignation date"
  },
  {
    key: "hiredEmployeeInfo.resignReason",
    displayTitle: "Resignation reason"
  }
];

export const EmployeeAddressInfoConfig: Record<string, string>[] = [
  {
    key: "hiredEmployeeInfo.address.country",
    displayTitle: "Country"
  },
  {
    key: "hiredEmployeeInfo.address.province",
    displayTitle: "Province"
  },
  {
    key: "hiredEmployeeInfo.address.district",
    displayTitle: "District"
  },
  {
    key: "hiredEmployeeInfo.address.sector",
    displayTitle: "Sector"
  },
  {
    key: "hiredEmployeeInfo.address.cell",
    displayTitle: "Cell"
  },
  {
    key: "hiredEmployeeInfo.address.village",
    displayTitle: "Village"
  }
];

export const AdditionalEmployeeInfoConfig: Record<string, string>[] = [
  {
    key: "additionalEmployeeInfo.schoolName",
    displayTitle: "School name"
  },
  {
    key: "additionalEmployeeInfo.degree",
    displayTitle: "Degree"
  },
  {
    key: "additionalEmployeeInfo.concentration",
    displayTitle: "Concentration/Major"
  },
  {
    key: "additionalEmployeeInfo.githubUrl",
    displayTitle: "Github"
  },
  {
    key: "additionalEmployeeInfo.linkedInUrl",
    displayTitle: "Linkedin"
  },
  {
    key: "additionalEmployeeInfo.portfolioUrl",
    displayTitle: "Portfolio"
  }
];
